import { BaseMapper } from '@ps/utils';
import { MentionableUser } from '@ps/survey-utils';

import { MentionableUserDto } from '../../dtos/mentionable-user.dto';

export class MentionableUserMapper extends BaseMapper<
  MentionableUserDto,
  MentionableUser
> {
  public fromDto(dto: MentionableUserDto): MentionableUser {
    return {
      id: dto.id,
      name: dto.name,
      email: dto.email,
      company: dto.company,
    };
  }
}
